// @ts-ignore
// eslint-disable-next-line no-unused-vars
import {IMaintenanceSearchParams, IMaintenanceState} from './maintenance-state.store'
import {ActionTree} from 'vuex'
import {IRootState} from '../root-state.store'
// @ts-ignore
import * as _ from './maintenance-types.store'
import {ActivityStatus, CrudStatus} from '../../common/enums'
import {EquipmentDto, IEquipment} from '../../models/equipment/equipment.model'
import {IMaintenanceService} from '../../services'
import {EQUIPMENT_UPDATE} from './maintenance-types.store'

export const actions: ActionTree<IMaintenanceState, IRootState> = {
  [_.MAINTENANCE_POST_CREATE]: ({commit, state, getters}) => {
    const service: IMaintenanceService = getters.service
    return service.postMaintenance(getters.maintenance)
  },

  [_.MAINTENANCE_PATCH_UPDATE]: ({commit, state, getters},id:string) => {
    const service: IMaintenanceService = getters.service
    return service.patchMaintenance(id,getters.maintenance)
  },

  [_.MAINTENANCE_TEMPLATE_POST_CREATE]: ({commit, state, getters}) => {
    const service: IMaintenanceService = getters.service
    return service.postMaintenanceTemplate(getters.maintenanceTemplate)
  },

  [_.MAINTENANCE_TEMPLATE_PATCH_UPDATE]: ({commit, state, getters},id:string) => {
    const service: IMaintenanceService = getters.service
    return service.patchMaintenanceTemplate(id,getters.maintenanceTemplate)
  },

  [_.EQUIPMENT_RESET]: ({commit, state}) => {
    commit(_.EQUIPMENT_SET, new EquipmentDto({number_equipment: 1}))
    commit(_.EQUIPMENT_ACTION, CrudStatus.NoAction)
  },

  [_.EQUIPMENT_EDIT]: ({commit, state, getters}) => {
    let currentEqp = Object.assign({}, {...getters.currentEquipment})
    if (currentEqp.contractors_assigned) {
      currentEqp.contractors_assigned = currentEqp.contractors_assigned.map(cts => {
        if (cts.id) return cts.id
        return cts
      })
    }
    commit(_.EQUIPMENT_SET, new EquipmentDto(currentEqp))
    console.log('Equipment to edit ===== ', getters.equipment)
    commit(_.EQUIPMENT_ACTION, CrudStatus.Update)
  },
  [_.EQUIPMENT_RECORD]: ({commit, state, getters}) => {
    const service: IMaintenanceService = getters.service
    return service.postEquipment(getters.equipment)
      .then(createdEquipment => {
        commit(_.EQUIPMENT_SET, {})
        commit(_.EQUIPMENT_CURRENT_SET, createdEquipment)
        return Promise.resolve(createdEquipment)
      })
      .catch(error => Promise.reject(error))
  },
  [_.EQUIPMENT_UPDATE]: ({commit, state, getters}) => {
    let currentEqp = Object.assign({}, {...getters.currentEquipment})
    if (currentEqp.contractors_assigned) {
      currentEqp.contractors_assigned = currentEqp.contractors_assigned.map(cts => {
        if (cts.id) return cts.id
        return cts
      })
    }
    let oldVal = new EquipmentDto(currentEqp)
    let changes = oldVal.compareChanges(getters.equipment)
    if (Object.keys(changes).length === 0) {
      return Promise.resolve({}).then(() => {
        commit(_.EQUIPMENT_SET, new EquipmentDto({}))
        commit(_.EQUIPMENT_ACTION, CrudStatus.NoAction)
      })
    }
    getters.service.patchEquipment(getters.equipment.id, changes)
      .then(response => {
        console.log('response ==', response)
        commit(_.EQUIPMENT_CURRENT_SET, response)
        commit(_.EQUIPMENT_SET, new EquipmentDto({}))
        commit(_.EQUIPMENT_ACTION, CrudStatus.NoAction)
      })
  },
  [_.EQUIPMENT_GET_EQUIPMENTS]: ({commit, state, getters}, params) => {
    return getters.service.getEquipments(params)
      .then(res => {
        commit(_.EQUIPMENT_SET_EQUIPMENTS, res.data)
        return res.data
      }).catch(error => {
        console.log(error)
      })
  },
  [_.EQUIPMENT_GET]: ({commit, state, getters}, id) => {
    return getters.service.getEquipment(id)
      .then(res => {
        commit(_.EQUIPMENT_CURRENT_SET, res)
        return res
      }).catch(error => {
        console.log(error)
      })
  },
  [_.VEHICLE_GET]: ({commit, state, getters}, id) => {
    return getters.service.getVehicle(id)
      .then(res => {
        commit(_.EQUIPMENT_CURRENT_SET, res)
        return res
      }).catch(error => {
        console.log(error)
      })
  },
  [_.MAINTENANCE_GET_INTERVAL_TYPES]: ({commit, state, getters}) => {
    return getters.service.getIntervalTypes()
      .then(res => {
        commit(_.MAINTENANCE_SET_INTERVAL_TYPES, res)
        return res
      }).catch(error => {
        console.log(error)
      })
  },
  [_.MAINTENANCE_GET_TEMPLATES]: ({commit, state, getters},params:any) => {
    return getters.service.getMaintenanceTemplates(params)
      .then(res => {
        commit(_.MAINTENANCE_SET_TEMPLATES, res.data)
        return res.data
      }).catch(error => {
        console.log(error)
      })
  },
  [_.MAINTENANCE_GET_MAINTENANCES]: ({commit, state, getters},infiniteHandlerState:any=undefined) => {
    //return getters.service.getMaintenances(payload)
    commit(_.MAINTENANCE_SET_ISLOADING, true)
    return getters.service.getMaintenances({...getters.maintenanceSearchParams, $skip:getters.maintenances.length}).then((response:any)=>{
      if (response !== undefined) {
        if (response.total > 0 && getters.maintenances.length <= response.total) {
          let concatList = getters.maintenances.concat(response.data)
          commit(_.MAINTENANCE_SET_MAINTENANCES,concatList)
        }
      }
      if (infiniteHandlerState !== undefined) {
        infiniteHandlerState.loaded()
        if (response !== undefined) {
          if (getters.maintenances.length >= response.total) {
            infiniteHandlerState.complete()
          }
        }
      } else {
        if(infiniteHandlerState)
        {
          infiniteHandlerState.reset()
        }
      }
    }).finally(()=>{
      commit(_.MAINTENANCE_SET_ISLOADING, false)
    })
  },
  [_.EQUIPMENT_GET]: ({commit, state, getters}, id) => {
    return getters.service.getEquipment(id)
      .then(res => {
        commit(_.EQUIPMENT_CURRENT_SET, res)
        return res
      }).catch(error => {
        console.log(error)
      })
  },
  [_.EQUIPMENT_BLOCK]: ({commit, state, getters}, resetPage = false) => {
    commit(_.EQUIPMENT_BLOCK, {
      loading: true
    })
    return getters.service.getEquipments({
      ...getters.blockEquipmentParameter,
      $skip: resetPage ? 0 : (getters.blockEquipmentData.currentPage - 1) * getters.blockEquipmentData.limit,
      $limit: getters.blockEquipmentData.limit//10
    })
      .then(res => {
        commit(_.EQUIPMENT_BLOCK, {
          list: res.data,
          total: res.total,
          totalPage: Math.ceil(res.total / getters.blockEquipmentData.limit),
          currentPage: resetPage ? 1 : getters.blockEquipmentData.currentPage
        })
        return res.data
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        commit(_.EQUIPMENT_BLOCK, {
          loading: false
        })
      })
  },
  [_.VEHICLE_FLEET_BLOCK]: ({commit, state, getters}, resetPage = false) => {
    commit(_.VEHICLE_FLEET_BLOCK, {
      loading: true
    })
    return getters.service.getVehicleFleet({
      ...getters.blockVehicleFleetParameter,
      $skip: resetPage ? 0 : (getters.blockVehicleFleet.currentPage - 1) * getters.blockVehicleFleet.limit,
      $limit: getters.blockVehicleFleet.limit
    })
      .then(res => {
        commit(_.VEHICLE_FLEET_BLOCK, {
          list: res.data,
          total: res.total,
          totalPage: Math.ceil(res.total / getters.blockVehicleFleet.limit),
          currentPage: resetPage ? 1 : getters.blockVehicleFleet.currentPage
        })
        return res.data
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        commit(_.VEHICLE_FLEET_BLOCK, {
          loading: false
        })
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/maintenance/maintenance-action.store.ts